import { EventEmitter, Injectable } from '@angular/core';
import { User, UserModel } from '../models/user';
import { DataService } from '../services/data.service';
import { map } from 'rxjs/operators'
import { Router } from '@angular/router';
import { RequestService } from './request.service';
import { Observable } from 'rxjs';
import { CommonResponse } from '../models/responses/common.response';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { STATUS } from '../enums/status.enum';
import { LocalStorage } from '../enums/local-storage-key.enum';
import { LocalStorageService } from './local-storage.service';
import { UtilityService } from './utility.service';
import { TermsDialogComponent } from '../dialog/terms-dialog/terms-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { LoadingService } from './loading.service';

export enum SocialLoginProvider {
  FACEBOOK = 'facebook',
  GOOGLE = 'google',
  APPLE = 'apple',
  HUAWEI = 'huawei'
}

@Injectable()
export class UserService {

  logOutEventEmitter: EventEmitter<boolean> = new EventEmitter();
  logInEventEmitter: EventEmitter<boolean> = new EventEmitter();

    constructor(
      private dataService: DataService,
      private request: RequestService,
      private router: Router,
      private http: HttpClient,
      private localStorageService: LocalStorageService,
      private utilityService: UtilityService,
      private dialog: MatDialog,
      private loadingService: LoadingService
    ) {
        this.baseUrl = dataService.baseUrl;
    }

    user!: User;
    response!: JSON;
    baseUrl: string;
    me!: UserModel;

    login(email: string, password: string): Promise<any> {
      return new Promise((onData, reject) => {
        let url = this.baseUrl + 'login';
        this.request.postJSON(url, {
          email: email,
          password: password
        })
        .subscribe({
          next: (response: any) => {
            if (response.status == 1) {
              this.dataService.setName(response.data.user.first_name, response.data.user.last_name);
              this.dataService.saveToken(response.data.token);
              this.onSuccessLogin(response.data);
              onData(response.data);
            }
            reject(response)
          },
          error: reject
        });
      })
        // return this.dataService.postJSON(url, data).pipe(
        //   map(response => response)
        // );
    }
    updateProfile(user: UserModel): Promise<void> {
      return new Promise((onUpdate, error) => {
        this.request.putJSON<any>(this.baseUrl + 'user/' + this.getUser()._id, user)
        .subscribe(
          response => {
            if (response.status == STATUS.SUCCESS) {
              this.setUser(response.data.user)
              onUpdate();
            } else error()
          },
          error
        )
      })
    }

    verifyResetPasswordCode(code: string | number): Promise<any> {
      return new Promise((onverify, onerror) => {
        this.http.post<CommonResponse>(
          environment.API_URL + 'send-mail/reset-password/verify-code',
          {
            code
          }
        )
        .subscribe(
          response => {
            if (response.status != STATUS.SUCCESS) return onerror(response);
            return onverify(response)
          },
          onerror
        );
      })
    }
    setUser(user: any): UserModel {
      return this.me = user;
    }

    getUser(): UserModel {
      return this.me;
    }

    getSelf(): Observable<any> {
      const url = this.baseUrl + "user/me";
      return this.request.getJSON<any>(url);
    }

    isLoggedIn() {
        return this.dataService.getToken() ? true : false;
    }

    logout() {
      this.logOutEventEmitter.emit();
      const lang = this.localStorageService.get(LocalStorage.LANG);
      this.localStorageService.deleteAll();
      this.localStorageService.set(LocalStorage.LANG, lang);
      this.router.navigate(['/auth/login'])
      .then(() => {
        this.setUser(null);
      })
    }

    register(user: any){
        let requestUrl = this.baseUrl + "register";
        this.user = new User();
        this.user.email = user.email;
        return this.dataService.postJSON(requestUrl, user).pipe(
          map(response => response)
        );
    }

    socialLogin(token: string, provider: SocialLoginProvider, channel: string, redirect_uri: string): Promise<any> {
      // this.loadingService.setLoading(true);
      return new Promise((onAuth, onError) => {
        this.http.post<CommonResponse>(environment.API_URL + 'login/social-account', {
          token,
          provider,
          channel,
          redirect_uri
        }).subscribe(
          response => {
            if (response.status != STATUS.SUCCESS) {
              return onError(response);
            }
            onAuth(response);
            // try {
            //   if (response.data?.user?.is_agree_term_condition) {
            //     this.dataService.saveToken(response.data.token);
            //     this.onSuccessLogin(response.data);
            //     this.loadingService.setLoading(false);
            //   } else {
            //     this.onAgreeDialog(response.data);
            //   }
            // } catch (error) {
            //   onError(error);
            // }
          },
          onError
        );
      })
    }

    onAgree(data: any): Promise<void> {
      this.loadingService.setLoading(true)
      const headers = new HttpHeaders({Authorization: 'Bearer ' + data?.token});
      headers.append("Content-Type", "application/json");
      return new Promise((onAuth, onError) => {
        this.http.put<any>(environment.API_URL + 'agree/term-condition',{},{
          headers
        }).subscribe(
          response => {
            if (response.status != STATUS.SUCCESS) return onError(response);
            try {
              this.dataService.saveToken(data?.token);
              this.onSuccessLogin(data);
              this.router.navigateByUrl('/purchases');
              this.loadingService.setLoading(false);
              onAuth();
            } catch (error) {
              this.loadingService.setLoading(false);
              onError(error);
            }
          },
          onError
        );
      })
    }

    onAgreeDialog(data: any) {
      this.loadingService.setLoading(false);
      this.dialog.open(TermsDialogComponent, {
        width: '1000px',
        disableClose: true,
        autoFocus: false,
        data: {
          type: 'registration',
          token: data?.token
        }
      })
      .afterClosed()
      .subscribe( result => {
        if (result) {
          this.onAgree(data);
        }
      })
    }
    auth0SignIn(token: string): Promise<void> {
      return new Promise((_, error) => {
        try {
          this.dataService.saveToken(token);
          _()
        } catch {
          error()
        }
      })
    }

    forgotPassword(email: String): Promise<any> {
        const url = this.baseUrl + "send-mail/reset-password";
        const headers = new HttpHeaders();
        headers.append("Content-Type", "application/json");
        return new Promise((onsend, onerror) => {
          this.http.post<any>(url, { email }, {
            headers: headers,
            responseType: 'json'
          }).subscribe({
            next: response => {
              if (response.status == 1)
                onsend(response);
              else onerror(response);
            },
            error: onerror
          })
        });
    }

    requestResetPassword(token:string){
        let requestUrl = this.baseUrl + "/password/change_password/" + token;
        return this.dataService.getJSON(requestUrl).pipe(
          map(response => response)
        );
    }

    resetPassword(data: {
      password: string,
      confirm_password: string,
      reset_password_token: string
    }): Promise<any> {
      const url = this.baseUrl + "reset-password";
      const headers = new HttpHeaders({
        Authorization: "Bearer " + data.reset_password_token
      });
      return new Promise((onReset, onError) => {
        this.http.post(
          url,
          { password: data.password, confirm_password: data.confirm_password },
          {
            headers: headers
          }
        )
        .subscribe({
          next: (response: any) => {
            if (response.status == STATUS.SUCCESS) onReset(response);
            else onError(response);
          },
          error: onError
        });
      })
    }

    verifyEmail(token: string): Promise<void> {
      return new Promise((onVerify, error) => {
        let requestUrl = this.baseUrl + "verify/" + token;
        this.request.getJSON(requestUrl)
        .subscribe((response: any) => {
          if (response.status == 1)
            onVerify();
          else
            error();
        });
      })
        // return this.dataService.getJSON(requestUrl);
    }
    uploadAvatar(avatar: any): Promise<any> {
      const url = this.baseUrl + 'user/avatar';
      const data = new FormData();
      data.append('avatar', avatar);
      return new Promise((onSuccess, onError) => {
        this.request.postJSON(url, data).subscribe({
          next: response => {
            onSuccess(response)
          },
          error: onError
        })
      });
    }

    resendVerifyEmail(email: string): Observable<CommonResponse> {
        const url = this.baseUrl + "resend/verify";
        return this.request.postJSON<CommonResponse>(url, {
          email
        });
    }

    changeProfile(profileName:any) {
        let requestUrl = this.baseUrl + "api/change_profile";
        profileName.token=this.dataService.getToken();
        return this.dataService.postJSON(requestUrl,profileName).pipe(
          map(response => response)
        );
    }

    changePassword(password: { old_password: string, new_password: string, confirm_new_password: string }): Promise<any> {
        const url = this.baseUrl + "change-password";
        return new Promise((onchange, onerror) => {
          this.request.postJSON<any>(url, password)
          .subscribe({
            next: response => {
              if (response.status == 1) onchange(response);
              else onerror(response)
            },
            error: onerror
          });
        });
    }

    getNewToken() {
      const url = this.baseUrl + 'refresh-token';
      return this.http.post(url, {}, { headers: this.getHeader() })
      .pipe(map((res: any) => {
        if (res.status === 1) {
          let expiry_time = res.data.expired_at;
          this.localStorageService.set(LocalStorage.token, res.data.token);
          this.localStorageService.set(LocalStorage.refresh_token, res.data.refresh_token);
          this.localStorageService.set(LocalStorage.expiry_time, expiry_time.toString());
        }
        return res;
      }));
    }

    public onSuccessLogin(res: any) {
      let expiry_time = res.expired_at;
      this.localStorageService.set(LocalStorage.token, res.token);
      this.localStorageService.set(LocalStorage.refresh_token, res.refresh_token);
      this.localStorageService.set(LocalStorage.expiry_time, expiry_time.toString());
      this.localStorageService.encryptSpecialCharacter(LocalStorage.user, JSON.stringify(res.user));
      this.localStorageService.set(LocalStorage.LANG, this.utilityService.getLang())
      this.logInEventEmitter.emit();
    }

    public getHeader() {
      const refresh_token = this.localStorageService.get(LocalStorage.refresh_token);
      return new HttpHeaders({
        'Content-Type': 'application/json',
        'authorization': `Bearer ${refresh_token} `
      });
    }
}
